'use client';

import { useFormContext } from 'react-hook-form';
import { cn } from '../../utils';
import { Input, type InputProps } from '../ui/input';
import { FormControl } from './FormControl';

export interface FormInputProps extends InputProps {
  name: string;
  label: string;
  subtitle?: string;
  className?: string;
}

export function FormInput({
  name,
  label,
  subtitle,
  className,
  disabled,
  ...props
}: FormInputProps) {
  const { register, formState } = useFormContext();

  return (
    <FormControl label={label} name={name} subtitle={subtitle}>
      <Input
        disabled={disabled || formState.isSubmitting}
        className={cn('w-full', className)}
        {...props}
        {...register(name)}
      />
    </FormControl>
  );
}
